/*
 *
 * ProfileAmbassador constants
 *
 */

export const GET_PLANS_WATCHER = "app/ProfileAmbassador/GET_PLANS_WATCHER"
export const GET_PLANS_FAILED = "app/ProfileAmbassador/GET_PLANS_FAILED"
export const GET_PLANS_SUCCESS = "app/ProfileAmbassador/GET_PLANS_SUCCESS"

export const UPDATE_PHOTO_WATCHER = "app/ProfileAmbassador/UPDATE_PHOTO_WATCHER"
export const UPDATE_PHOTO_FAILED = "app/ProfileAmbassador/UPDATE_PHOTO_FAILED"
export const UPDATE_PHOTO_SUCCESS = "app/ProfileAmbassador/UPDATE_PHOTO_SUCCESS"
